export default __webpack_public_path__ + "static/media/feature6_1.eb569441.png";